function getProtocolLink(chain: string, protocol: string, address: string): string {
    switch (chain) {
        case 'eth':
            return `https://etherscan.io/address/${address}`;
        case 'bsc':
            return `https://bscscan.com/address/${address}`;
        case 'base':
            return `https://basescan.org/address/${address}`;
        case 'arbitrum':
            return `https://arbiscan.io/address/${address}`;
        default:
            return `https://etherscan.io/address/${address}`;
    }
}

function getAddressLink(chain: string, address: string): string {
    switch (chain) {
        case 'eth':
            return `https://etherscan.io/address/${address}`;
        case 'bsc':
            return `https://bscscan.com/address/${address}`;
        case 'base':
            return `https://basescan.org/address/${address}`;
        case 'arbitrum':
            return `https://arbiscan.io/address/${address}`;
        default:
            return `https://etherscan.io/address/${address}`;
    }
}

export default {
    getProtocolLink,
    getAddressLink,
};
